import algoliasearch from 'algoliasearch';

import {config} from '@/constants/config';

const client = algoliasearch(config.ALGOLIA_APP_ID, config.ALGOLIA_API_KEY);

export const algolia = {
  playlists: client.initIndex('playlists'),
};
